import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'

// Element UI
import ElementUI, { Message } from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
// import 'element-ui/lib/theme-chalk/index.css'
import './element-variables.scss'

Vue.use(ElementUI, { locale })

/* eslint-disable */
// import api from './api'
/* eslint-enable */

// init login info
store.dispatch('oauth/initAccessToken')

// register login check
router.beforeEach((to, from, next) => {
  if (to.meta.title) { document.title = to.meta.title }

  // 仓库及司机不能登录
  const roleNum = Number(localStorage.getItem('role'))
  const isWhsStaff = roleNum === 5 || roleNum === 6
  if (to.name !== 'Login' && isWhsStaff) {
    store.dispatch('oauth/logoutAction')
    next({ name: 'Login' })
    Message.error({
      showClose: true,
      duration: 3500,
      dangerouslyUseHTMLString: true,
      message: 'No access permission for warehouse staff.'
    })
    return
  }

  if (to.name !== 'Login' && !store.getters['oauth/isLogin']) {
    next({ name: 'Login' })
  } else if ((to.name === 'Login' && store.getters['oauth/isLogin']) ||
    (to.name === 'Main' && store.getters['oauth/isLogin'])
  ) {
    next({ name: 'Quotings' })
  } else {
    next()
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
